// @ts-strict-ignore
import * as React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { antGrey } from '../styles/globalStyles';
import { StepItemLinkContainer, StepItemText, StepItemTextContainer } from './StepItem';
import Icon, { SignalFilled } from '@ant-design/icons';

interface AdditionalItemProps {
    itemText: string;
    route: string;
    icon: typeof SignalFilled;
    leftNode?: React.ReactNode;
    isLastNode?: boolean;
}
const AdditionalItem = ({ itemText, route, icon, leftNode, isLastNode = false }: AdditionalItemProps) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const match = useRouteMatch(route);
    const isActive = !!match;
    return (
        <li onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <Link to={route}>
                <StepItemLinkContainer isActive={isActive} isHovered={isHovered} isLastNode={isLastNode}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', minWidth: 0 }}>
                        {leftNode}
                        <StepItemTextContainer>
                            <StepItemText>{itemText}</StepItemText>
                        </StepItemTextContainer>
                        <Icon
                            component={icon}
                            style={{ color: antGrey.grey7, paddingTop: '12px', paddingBottom: '12px', marginLeft: 8 }}
                        />
                    </div>
                </StepItemLinkContainer>
            </Link>
        </li>
    );
};

export default AdditionalItem;
